$(function () {
    getChildColumn();
});

function getChildColumn() {
    var columns = getChildColumns('zypd');
    if (columns && columns.length > 0) {
        var html = '';
        for (var i = 0; i < columns.length; i++) {
            var info = columns[i];
            html += '<div class="child-column">';
            html += '<div class="child-column-title">';
            html += '<div class="child-column-name">' + info.name + '</div>';
            html += '</div>';
            html += '<div class="list" dataid="' + info.id + '" page="1"></div>';
            html += '<div class="more" dataid="' + info.id + '" style="display: none;">དེ་བས་མང་།</div>';
            html += '</div>';
        }
        $('.child-columns').html(html);
        $('.child-column .more').on('click', function () {
            var id = $(this).attr('dataid');
            getChildContents(id);
        });

        for (var i = 0; i < $('.child-column .list').length; i++) {
            var id = $($('.child-column .list')[i]).attr('dataid');
            getChildContents(id);
        }
    }
}

function getChildContents(id) {
    if (!id) return;
    var page = $('.child-column .list[dataid=' + id + ']').attr('page');

    $.ajax({
        type: 'get',
        async: false,
        url: ROOT + '/home/contents?id=' + id + '&page=' + page + '&size=8',
        data: null,
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            if (data && data.data && data.data.length > 0) {
                var html = '';
                for (var i = 0; i < data.data.length; i++) {
                    var info = data.data[i];
                    var img = ROOT + '/static/images/no-thumb.png';
                    if (info.thumbnail_urls && info.thumbnail_urls[0]) {
                        img = info.thumbnail_urls[0] + '?w=269&h=151&s=3';
                    }
                    var url = ROOT + '/zypd/' + info.id;
                    html += '<div class="newsItem">';
                    html += '<a href="' + url + '" class="newsItem-img"><img src="' + img + '" /></a>';
                    html += '<a href="' + url + '" class="newsItem-title">' + info.title + '</a>';
                    html += '</div>';
                }
                if (data.data.length % 4 != 0) {
                    for (var i = data.data.length % 4; i < 4; i++) {
                        html += '<div class="newsItem"></div>';
                    }
                }
                $('.child-column .list[dataid=' + id + ']').append(html);
                $('.child-column .list[dataid=' + id + ']').attr('page', parseInt(page) + 1);
                if (data.data.length < 8) {
                    $('.child-column .more[dataid=' + id + ']').css('display', 'none');
                } else {
                    $('.child-column .more[dataid=' + id + ']').css('display', 'block');
                }
            } else {
                console.log('未获取到子栏目内容');
                console.log(data);
            }
        },
        error: function (data) {
            console.log('获取到子栏目内容失败');
            console.log(data);
        }
    });
}

function toListHtml(data) {
    var newlist = '';
    for (var i = 0; i < data.data.length; i++) {
        var info = data.data[i];
        if (info.thumbnail_urls === undefined || info.thumbnail_urls == null || info.thumbnail_urls == '')
            info.thumbnail_urls = [];

        var bottominfo = '';
        bottominfo += '<div class="news_info">';
        bottominfo += '<div class="user">' + info.author_nickname + '</div>';
        bottominfo += '<div class="time">' + info.publish_time + '</div>';
        bottominfo += '<div class="reply">';
        if (info.comment_count > 0)
            bottominfo += '<div class="reply_count">' + info.comment_count + '评论</div>';
        if (info.view_count > 0)
            bottominfo += '<div class="reply_count">' + info.view_count + '浏览</div>';
        bottominfo += '</div>';
        if (info.source)
            bottominfo += '<div class="source">来源: ' + info.source + '</div>';
        bottominfo += '</div>';

        newlist += '<div class="newsItem">';
        // 只显示有图和无图两种情况
        if (info.list_item_mode == 0 || info.thumbnail_urls.length == 0 || !info.thumbnail_urls[0]) { // 无图
            newlist += '<div class="newsInfo noPic">';
            newlist += '<div class="news_body">';
            newlist += '<a class="news_title" href="' + info.url + '" target="_blank">' + info.title + '</a>';
            newlist += '<div class="news_content">';
            if (info.summary)
                newlist += info.summary;
            newlist += '</div>';
            newlist += bottominfo;
            newlist += '</div>';
            newlist += '</div>';
        } else {
            newlist += '<div class="newsPicture">';
            newlist += '<a href="' + info.url + '" target="_blank">';
            newlist += '<img src="' + info.thumbnail_urls[0] + '?w=170&h=114&s=3' + '"/>';
            newlist += '</a>';
            newlist += '</div>';
            newlist += '<div class="newsInfo">';

            newlist += '<div class="news_body">';
            newlist += '<a class="news_title" href="' + info.url + '" target="_blank">' + info.title + '</a>';
            if (info.summary) {
                newlist += '<div class="news_content">';
                newlist += info.summary;
                newlist += '</div>';
            }
            newlist += bottominfo;
            newlist += '</div>';
            newlist += '</div>';
        }
        newlist += '</div>';
        newlist += '<div class="dividing-line"></div>';
    }
    return newlist;
}
